// This is a really hacky way to add "2" to the charcoal logo
// but it works...
const versionNumberEl = document.createElement('span');

versionNumberEl.innerText = '2';
versionNumberEl.classList.add('c-nav-container_logo_version');

document.querySelector(".c-nav-container_logo").appendChild(versionNumberEl);
